import * as React from 'react';
export default class Spinner extends React.Component<any, any> {
  public render() {
  
    return (
      <div className="loader" />
    )

  }
}